/* Breadcrumbs.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import BreadcrumbsOriginal, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import React from 'react';
import { charlieTextFontFamily } from '../FontFamily';
const _7 = "._13t31tcg span{line-height:24px}";
const _6 = "._nzz5oxwj span{font-size:.875rem}";
const _5 = "._1kd31nn1 span{font-weight:400}";
const _4 = "._1uq94jg8 span{font-style:normal}";
const _3 = "._1tjq1k3w span{color:var(--ds-text-subtle)}";
const _2 = "._ij3o1sdi span{font-family:Charlie Text,-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}";
const _ = "._1dzo18uv :after, ._gxv518uv :before{box-sizing:initial}";
const BreadcrumbsWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1dzo18uv _gxv518uv _ij3o1sdi _1tjq1k3w _1uq94jg8 _1kd31nn1 _nzz5oxwj _13t31tcg", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  BreadcrumbsWrapper.displayName = 'BreadcrumbsWrapper';
}
export const Breadcrumbs = props => {
  return /*#__PURE__*/React.createElement(BreadcrumbsWrapper, {
    className: props.className
  }, /*#__PURE__*/React.createElement(BreadcrumbsOriginal, props));
};
export { BreadcrumbsItem };